export default "__VITE_ASSET__BeN0d4zs__"